import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import BlogGroup from "../components/BlogGroup";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import NavBar from "../components/NavBar";

const Blog = () => {
  return (
    <>
      <SEO canonical="/blog" {...PAGES["/blog"]} />
      {/* Navigation Bar */}
      <NavBar />

      {/* Navigation Bar */}
      <Breadcrumb title={"Blog"} />

      {/* Blog Group */}
      <BlogGroup />

      {/* Footer One */}
      <FooterOne />
    </>
  );
};

export default Blog;
